<script>
import { debounce, cloneDeep, isEqual } from 'lodash';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import ActivityFilter from '../filters/activity_filter.vue';
import ActivityFilterDeprecated from '../filters/activity_filter_deprecated.vue';
import ProjectFilterDeprecated from '../filters/project_filter_deprecated.vue';
import ProjectFilter from '../filters/project_filter.vue';
import ScannerFilter from '../filters/scanner_filter.vue';
import SimpleFilter from '../filters/simple_filter.vue';
import ClusterFilter from '../filters/cluster_filter.vue';
import ClusterFilterDeprecated from '../filters/cluster_filter_deprecated.vue';
import ImageFilterDeprecated from '../filters/image_filter_deprecated.vue';
import ImageFilter from '../filters/image_filter.vue';
import ToolFilter from '../filters/tool_filter.vue';
import ToolFilterDeprecated from '../filters/tool_filter_deprecated.vue';
import ToolWithVendorFilter from '../filters/tool_with_vendor_filter.vue';
import SeverityFilter from '../filters/severity_filter.vue';
import StatusFilter from '../filters/status_filter.vue';
import { FILTERS } from './constants';

const { ACTIVITY, TOOL_VENDOR, TOOL_SIMPLE, PROJECT, CLUSTER, IMAGE, SEVERITY, STATUS } = FILTERS;

export default {
  mixins: [glFeatureFlagsMixin()],
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      filterQuery: {},
      // When this component is first shown, every filter will emit its own @filter-changed event at
      // the same time, which will trigger this method multiple times. We'll debounce it so that it
      // only runs once. Note that this is in data() so that it's unique per instance. Otherwise,
      // every instance of this component will share the same debounce function.
      emitFilterChange: debounce(function emit() {
        this.$emit('filters-changed', this.filterQuery);
      }),
    };
  },
  methods: {
    getComponentType(filter) {
      const { refactorVulnerabilityFilters, refactorVulnerabilityToolFilter } = this.glFeatures;

      switch (filter) {
        case SEVERITY:
          return refactorVulnerabilityFilters ? SeverityFilter : SimpleFilter;
        case STATUS:
          return refactorVulnerabilityFilters ? StatusFilter : SimpleFilter;
        case TOOL_VENDOR:
          return refactorVulnerabilityFilters ? ToolWithVendorFilter : ScannerFilter;
        case TOOL_SIMPLE:
          if (refactorVulnerabilityToolFilter) {
            return ToolFilter;
          }
          if (refactorVulnerabilityFilters) {
            return ToolFilterDeprecated;
          }
          return SimpleFilter;
        case ACTIVITY:
          return refactorVulnerabilityFilters ? ActivityFilter : ActivityFilterDeprecated;
        case PROJECT:
          return refactorVulnerabilityFilters ? ProjectFilter : ProjectFilterDeprecated;
        case CLUSTER:
          return refactorVulnerabilityFilters ? ClusterFilter : ClusterFilterDeprecated;
        case IMAGE:
          return refactorVulnerabilityFilters ? ImageFilter : ImageFilterDeprecated;
        default:
          return SimpleFilter;
      }
    },
    updateFilterQuery(query) {
      const oldQuery = cloneDeep(this.filterQuery);
      this.filterQuery = { ...this.filterQuery, ...query };
      // Don't emit if the filters didn't change because it will trigger the GraphQL queries to run.
      if (!isEqual(oldQuery, this.filterQuery)) {
        this.emitFilterChange();
      }
    },
  },
};
</script>

<template>
  <div
    class="vulnerability-report-filters gl-p-5 gl-bg-gray-10 gl-border-b-1 gl-border-b-solid gl-border-b-gray-100"
  >
    <component
      :is="getComponentType(filter)"
      v-for="filter in filters"
      :key="filter.id"
      :filter="filter"
      :data-testid="filter.id"
      @filter-changed="updateFilterQuery"
    />
  </div>
</template>
